import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';


/**
 * Función para listar el control de pagos a través del ID del arrendamiento
 * @param {*} param0 
 * @returns 
 */
export const useFetchPaymentsByContract = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        contrato_codigo: ''
    })

    // 1. Para los datos recuperados de la BD
    const [dataPayments, setDataPayments] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchPaymentsByContract, setLoadingFetchPaymentsByContract ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataPayments([])
        setParamsToSearch({
            contrato_codigo: ''
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const idcontrato = parseInt(paramsToSearch.contrato_codigo.match(/\d+/)[0], 10);
            const response = await marvarApi.get(`/leases/management-payments/all-pagos/${idcontrato}`)
            // console.log('[useFetchData][useFetchPaymentsByContract] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.contrato_codigo !== '' ){
            setLoadingFetchPaymentsByContract(true)
            fetchData()
                .then((resp) => {
                    // setDataPayments(resp.rows)
                    setDataPayments(resp.rows)
                    setLoadingFetchPaymentsByContract(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchPaymentsByContract(false)
                })
        }
    }, [execute])

    return { dataPayments, loadingFetchPaymentsByContract, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchInfoLease = ({marvarApi, dispatch, onLogout, Forms}) =>{
    
    // 2. Para mostrar animación de carga
    const [ dataInfoLease, setDataInfoLease ] = useState([])

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoLease, setLoadingFetchInfoLease ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({
        contrato_codigo: ''
    })

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const idcontrato = parseInt(paramsToSearch.contrato_codigo.match(/\d+/)[0], 10);
            const response = await marvarApi.get(`/leases/common/application/${idcontrato}`)
            // console.log('[useFetchData][useFetchInfoLease] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.contrato_codigo !== '' ){
            setLoadingFetchInfoLease(true)
            fetchData()
                .then((resp) => {
                    
                    setDataInfoLease(resp.data)
                    setLoadingFetchInfoLease(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoLease(false)
                })
        }
    }, [execute])

    return { dataInfoLease, loadingFetchInfoLease, setParamsToSearch, executeFetch }
}
/**
 * Función para listar los movimientos registrados por pagos al momento de abrir la modal
 * @param {*} param0 
 * @returns 
 */
export const useFetchTransactionsByPayment = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        idpago: ''
    })

    // 1. Para los datos recuperados de la BD
    const [dataTransactions, setDataTransactions] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataTransactions([])
        setParamsToSearch({
            idpago: ''
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/management-payments/all-movimientos/${paramsToSearch.idpago}`)
            // console.log('[useFetchData][useFetchTransactionsByPayment] response.data ', response.data)
            // return response.data
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idpago !== '' ){
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataTransactions(resp.rows)
                    setDataTransactions(resp.rows)
                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataTransactions, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

/**
 * Función para obtener info de un movimiento especifco (para visualizar detalles)
 * @param {*} param0 
 * @returns 
 */
export const useFetchSpecificTransaction = ({marvarApi, dispatch, onLogout, Helpers, pdfManager}) => {

    const defaultParams = {
        idmovimiento: '',
        fecthTransactionInfo: {
            flag: false,
            refSetFormState: null
        },
        printTicketFlag: false
    }
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)

    // 1. Para los datos recuperados de la BD
    const [dataSpecificTransaction, setDataSpecificTransaction] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataSpecificTransaction([])
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/management-payments/info-movimiento/${paramsToSearch.idmovimiento}`)
            // console.log('[useFetchData][useFetchSpecificTransaction] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento !== '' ){
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataSpecificTransaction(resp.rows)
                    setDataSpecificTransaction(resp.rows)

                    // Para extraer info de un solo contenedor
                    if(paramsToSearch.fecthTransactionInfo?.flag){

                        paramsToSearch.fecthTransactionInfo.refSetFormState(prevState => ({
                            ...prevState,
                            idmovimiento: resp.rows[0].idmovimiento,
                            idpago: resp.rows[0].idpago,
                            idcaja: resp.rows[0].caja,
                            idbanco: resp.rows[0].idbanco,
                            movimiento_fecha: resp.rows[0].movimiento_fecha,
                            movimiento_tipo: resp.rows[0].movimiento_tipo,
                            movimiento_monto: resp.rows[0].movimiento_monto,
                            movimiento_moneda: resp.rows[0].movimiento_moneda,
                            movimiento_tipo_cambio: resp.rows[0].movimiento_tipo_cambio,
                            movimiento_quetzales: resp.rows[0].movimiento_quetzales,
                            movimiento_dolares: resp.rows[0].movimiento_dolares,
                            movimiento_observaciones: resp.rows[0].movimiento_observaciones,
                            boleta_numero: resp.rows[0].boleta_numero,
                            boleta_foto_originalname: resp.rows[0].boleta_foto_originalname,
                            boleta_foto_filename: resp.rows[0].boleta_foto_filename,
                            boleta_foto_path: resp.rows[0].boleta_foto_path,
                            aprobacion_check: resp.rows[0].aprobacion_check,
                            aprobacion_fecha: resp.rows[0].aprobacion_fecha,
                            aprobacion_observaciones: resp.rows[0].aprobacion_observaciones
                        }))

                    }

                    if (paramsToSearch?.printTicketFlag === true){
                        console.log('imprimiendo PDF')
                        Helpers.drawPaymentTicket(pdfManager, resp.rows[0])
                    }

                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataSpecificTransaction, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchAllCashRegisters = ({marvarApi, dispatch, onLogout}) => {
    
    const [cashRegisters, setCashRegisters] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setCashRegisters([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-cash-registers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCashRegisters(true)
        fetchData()
            .then((resp) => {
                const { data } = resp
                setCashRegisters(data)
                setLoadingFetchCashRegisters(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCashRegisters(false)
            })
    }, [execute])

    return { cashRegisters, loadingFetchCashRegisters, executeFetch, resetFetch }
}

export const useFetchAllBanks = ({marvarApi, dispatch, onLogout}) => {
    
    const [banks, setBanks] = useState([])

    const [ loadingFetchBanks, setLoadingFetchBanks ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setBanks([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-banks`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchBanks(true)
        fetchData()
            .then((resp) => {
                const { data } = resp

                setBanks(data)
                setLoadingFetchBanks(false)

            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchBanks(false)
            })
    }, [execute])

    return { banks, loadingFetchBanks, executeFetch, resetFetch }
}